import { render } from "./PlayerVideo.vue?vue&type=template&id=03767d2d"
import script from "./PlayerVideo.vue?vue&type=script&lang=js"
export * from "./PlayerVideo.vue?vue&type=script&lang=js"

import "./PlayerVideo.vue?vue&type=style&index=0&id=03767d2d&lang=css"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__